import { TripType } from '@fcom/core/constants';

export const CmsTripTypeMap = {
  [TripType.ONEWAY]: 'oneWay',
  [TripType.RETURN]: 'return',
  [TripType.MULTICITY]: 'multiCity',
};
